import { useState, useEffect } from 'react';
import moment from 'moment';
import { fetchStudioOverallOverviewPageData } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import { getOptionsWithSeparatedGroupKey } from '@gp/utils/common';
import {
  getOptionsByStringValues,
  getLastYearAndCurrentYear,
} from '@gp/pages/StudioDashboard/StudioOverall/utils';

export default function useOverviewPageData() {
  const [isLoading, setIsLoading] = useState(true);
  const [pageData, setPageData] = useState<IStudioOverallOverviewCommonData>({
    categories: [],
    businesses: [],
    regionsCountriesData: [],
    dataTime: '',
    lastYear: '',
    currentYear: '',
  });

  const initPageData = async () => {
    try {
      setIsLoading(true);
      const res: any = await fetchStudioOverallOverviewPageData();
      const dataTime = res?.date_time;
      const { currentYear, lastYear } = getLastYearAndCurrentYear({
        currentYear: moment(dataTime).format('YYYY'),
      });
      const categories = getOptionsWithSeparatedGroupKey(
        getOptionsByStringValues(res?.category),
      );
      const businesses = getOptionsWithSeparatedGroupKey(
        getOptionsByStringValues(res?.business_owner),
      );
      const pageData = {
        categories: categories || [],
        businesses: businesses || [],
        regionsCountriesData: res?.region || [],
        dataTime: dataTime || '',
        currentYear,
        lastYear,
      };
      setPageData(pageData);
    } catch (exception) {
      console.warn(exception);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    initPageData();
  }, []);

  return {
    isLoading,
    pageData,
  };
}
